import React from 'react';

export const CartEmptyIcon = () => {
    return (
        <span key={Math.random()} className="cart-empty-icon">
            <span className="fa-stack fa-3x">
                <i className="fal fa-shopping-cart fa-stack-2x text-black-30" />
                <i
                    className="fas fa-circle fa-stack-1x text-black-30"
                    data-fa-transform="shrink-13 left-3 up-5"
                />
                <i
                    className="fas fa-circle fa-stack-1x text-black-30"
                    data-fa-transform="shrink-13 right-8 up-5"
                />
                <i
                    className="fas fa-spinner-third fa-stack-1x text-black-30"
                    data-fa-transform="shrink-10 right-3 down-1 rotate-300"
                />
            </span>
        </span>
    );
};
